import _class_call_check from "@swc/helpers/src/_class_call_check.mjs";
import _create_class from "@swc/helpers/src/_create_class.mjs";
var Options = /*#__PURE__*/ function() {
    "use strict";
    function Options() {
        _class_call_check(this, Options);
        this._useMonthly = false;
        this._mappings = {
            makes: {},
            models: {},
            variants: {}
        };
        this._ageData = [];
        this._facets = undefined;
        this._storeData = [];
    }
    _create_class(Options, [
        {
            key: "useMonthly",
            get: function get() {
                return this._useMonthly;
            },
            set: function set(useMonthly) {
                this._useMonthly = useMonthly;
            }
        },
        {
            key: "mappings",
            get: function get() {
                return this._mappings;
            },
            set: function set(mappings) {
                this._mappings = mappings;
            }
        },
        {
            key: "ageData",
            get: function get() {
                return this._ageData;
            },
            set: function set(ageData) {
                this._ageData = ageData;
            }
        },
        {
            key: "facets",
            get: function get() {
                return this._facets;
            },
            set: function set(facets) {
                this._facets = facets;
            }
        },
        {
            key: "storeData",
            get: function get() {
                return this._storeData;
            },
            set: function set(storeData) {
                this._storeData = storeData;
            }
        }
    ]);
    return Options;
}();
export var options = new Options();
